/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import withFirebaseAuth from "react-with-firebase-auth";
import firebase from "firebase";
import "firebase/auth";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { auth } from "../firestore_user";
import { onDistributionAuthResult } from "./syncDistributionProfile";

const uiConfig = {
  // Popup signin flow rather than redirect flow.

  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
  ],
  signInSuccessUrl: "/",
  callbacks: {
    signInSuccessWithAuthResult(authResult) {
      onDistributionAuthResult(authResult);
      return false;
    },
  },
};

const firebaseAppAuth = auth;

const providers = {};

const Auth = ({ show, parentMethod, user, signOut }) => {
  const auth = {
    user: user,
    signOut: signOut,
  };

  const findUser = () => {
    //console.log(auth);
    parentMethod(auth ? auth : "null");
  };
  useEffect(() => {
    findUser();
  }, [auth && auth.user && auth.user.uid]);
  return (
    show && (
      <StyledFirebaseAuth
        uiConfig={uiConfig}
        firebaseAuth={auth}
        uiCallback={(ui) => ui.reset()}
      />
    )
  );
};

export default withFirebaseAuth({
  providers,
  firebaseAppAuth,
})(Auth);
